(function () {
  if (window.customMenuInitialized) return;
  window.customMenuInitialized = true;

  function initMenu() {
    const menu = document.getElementById('custom-mobile-menu');
    const toggle = document.querySelector('.custom-menu-toggle');
    const close = document.querySelector('.custom-menu-close');

    if (!menu || !toggle || !close) return;

    /* OPEN MENU */
    toggle.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.add('open');

      // ✅ body lock remove
      document.documentElement.classList.add('menu-open');
    });

    /* CLOSE MENU */
    close.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.remove('open');

      document.documentElement.classList.remove('menu-open');
    });

    /* ACCORDION */
    menu.querySelectorAll('.accordion-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const submenu = btn.nextElementSibling;
        if (!submenu || !submenu.classList.contains('submenu')) return;

        const isOpen = btn.classList.contains('active');

        btn.closest('ul')
          .querySelectorAll('.submenu.open')
          .forEach(el => {
            if (el !== submenu) {
              el.classList.remove('open');
              el.previousElementSibling?.classList.remove('active');
            }
          });

        btn.classList.toggle('active', !isOpen);
        submenu.classList.toggle('open', !isOpen);
      });
    });

    /* CLOSE ON LINK CLICK */
    menu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        menu.classList.remove('open');
        document.documentElement.classList.remove('menu-open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMenu);
  document.addEventListener('shopify:section:load', initMenu);
})();
